import type { ReactNode } from 'react';
import { usePermission } from '@backstage/plugin-permission-react';
import { BasicPermission, ResourcePermission } from '@backstage/plugin-permission-common';

interface ConditionalPermissionProps {
  permission: BasicPermission | ResourcePermission;
  resourceRef?: string;
  children: ReactNode;
}

export const ConditionalPermission = ({
  permission,
  resourceRef,
  children,
}: ConditionalPermissionProps) => {
  const { loading, allowed } = usePermission(
    permission.type === 'basic' 
      ? { permission: permission as BasicPermission }
      : { permission: permission as ResourcePermission, resourceRef }
  );

  if (loading) {
    return null;
  }

  if (!allowed) {
    return null;
  }

  return <>{children}</>;
};
